import React from "react";

// Football kit (jersey + shorts) live SVG preview
const BODY = "M100,55 L200,55 L248,102 L222,140 L208,124 L208,258 L92,258 L92,124 L78,140 L52,102 Z";

const KitPreview = ({ design, svgId = "design-svg" }) => {
  const { pattern, primary, secondary, accent, teamName, number, logo } = design;

  const stripes = [];
  if (pattern === "stripes") {
    for (let x = 92; x < 208; x += 24) {
      stripes.push(<rect key={x} x={x} y={40} width={12} height={230} fill={secondary} />);
    }
  }
  const hoops = [];
  if (pattern === "hoops") {
    for (let y = 70; y < 258; y += 34) {
      hoops.push(<rect key={y} x={40} y={y} width={220} height={17} fill={secondary} />);
    }
  }

  return (
    <svg id={svgId} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400" width="300" height="400" className="w-full h-auto">
      <rect width="300" height="400" fill="#f6f7f9" />
      <defs>
        <clipPath id="kitBody"><path d={BODY} /></clipPath>
      </defs>

      {/* Jersey base */}
      <path d={BODY} fill={primary} />
      <g clipPath="url(#kitBody)">
        {pattern === "stripes" && stripes}
        {pattern === "hoops" && hoops}
        {pattern === "halves" && <rect x={150} y={40} width={110} height={230} fill={secondary} />}
        {pattern === "sash" && <polygon points="52,150 248,60 248,95 52,185" fill={accent} />}
      </g>

      {/* Collar */}
      <polygon points="128,55 172,55 160,76 140,76" fill={accent} />
      {/* Sleeve cuffs */}
      <path d="M52,102 L78,140 L70,150 L44,112 Z" fill={accent} />
      <path d="M248,102 L222,140 L230,150 L256,112 Z" fill={accent} />
      {/* Body outline */}
      <path d={BODY} fill="none" stroke="#00000022" strokeWidth="2" />

      {/* Team name */}
      {teamName ? (
        <text x="150" y="104" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="700" fontSize="16" fill={accent} style={{ textTransform: "uppercase" }}>{teamName}</text>
      ) : null}
      {/* Number */}
      {number ? (
        <text x="150" y="205" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="800" fontSize="92" fill={accent} stroke="#00000030" strokeWidth="1.5">{number}</text>
      ) : null}
      {/* Crest / sponsor logo */}
      {logo ? <image href={logo} x="112" y="120" width="36" height="36" preserveAspectRatio="xMidYMid meet" /> : null}

      {/* Shorts */}
      <g>
        <path d="M110,278 L190,278 L188,300 L152,300 L150,352 L120,352 L112,300 Z" fill={primary} stroke="#00000022" strokeWidth="2" />
        <path d="M190,278 L188,300 L152,300 L152,352 L182,352 L190,300 Z" fill={pattern === "halves" ? secondary : primary} />
        <rect x="110" y="274" width="80" height="8" fill={accent} />
        {number ? <text x="127" y="330" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="800" fontSize="22" fill={accent}>{number}</text> : null}
      </g>
    </svg>
  );
};

export default KitPreview;
